import * as React from "react";

/**
 * State a component owns until its parent takes it over: uncontrolled with
 * `defaultValue`, controlled with `value`. `onChange` fires either way, so a
 * parent can listen without owning the value.
 */
export const useControllableState = <T>({
  value,
  defaultValue,
  onChange,
}: {
  value?: T;
  defaultValue: T;
  onChange?: (next: T) => void;
}) => {
  const [own, setOwn] = React.useState(defaultValue);
  const controlled = value !== undefined;
  const current = controlled ? value : own;
  const setValue = React.useCallback(
    (next: T) => {
      if (!controlled) setOwn(next);
      onChange?.(next);
    },
    [controlled, onChange],
  );
  return [current, setValue] as const;
};
